import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import Container from '@mui/material/Container';

import SectionTitle from '@/components/SectionTitle/SectionTitle';
import usePageTitle from '@/hooks/usePageTitle';
import MLParcel from '@/sections/plugins/MLParcel';

const MLParcelPage = () => {
  usePageTitle('Integraciones - Mercado Libre Parcel');

  return (
    <Container maxWidth="xxl">
      <SectionTitle title="Mercado Libre Parcel" mt={5}>
        <LocalShippingOutlinedIcon fontSize="large" />
      </SectionTitle>

      <MLParcel />
    </Container>
  );
};

export default MLParcelPage;
